
import { Component, Injector, Input, OnInit } from '@angular/core';
import { DetailFormService } from 'tnx-admin-service/detailform/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';

@Component({
    selector: 'detailform-form',
    templateUrl: './detailform-form.component.html',
    styleUrls: ['./detailform-form.component.scss'],
    providers: [ComponentContextService],
})
export class DetailFormFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _detailFormService: DetailFormService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._detailFormService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'soThuTu',
                label: ''
            }),
            new TextControlSchema({
                field: 'idColumn',
                label: ''
            }),
            new TextControlSchema({
                field: 'code',
                label: 'Mã'
            }),
            new TextControlSchema({
                field: 'currentStateCode',
                label: ''
            })
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

